import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function UrgencyBar() {
  const [timeLeft, setTimeLeft] = useState({
    minutes: 14,
    seconds: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds === 0) {
          if (prev.minutes === 0) return prev;
          return {
            minutes: prev.minutes - 1,
            seconds: 59
          };
        }
        return {
          ...prev,
          seconds: prev.seconds - 1
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div className="sticky top-0 z-50 bg-[#c2410c] text-white py-2 px-4 text-center shadow-md" data-id="element-22">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row justify-center items-center gap-2 text-sm sm:text-base font-medium" data-id="element-23">
        <span className="flex items-center gap-2" data-id="element-24">
          <Clock className="w-4 h-4" data-id="element-25" />
          ¡Oferta por tiempo limitado!
        </span>
        <span className="hidden sm:inline" data-id="element-26">|</span>
        <span data-id="element-27">
          Solo quedan{' '}
          <span className="font-bold underline decoration-white/50" data-id="element-28">
            7 copias
          </span>{' '}
          a precio promocional
        </span>
        <span className="bg-white/20 px-2 py-0.5 rounded text-xs font-bold" data-id="element-29">
          {String(timeLeft.minutes).padStart(2, '0')}:
          {String(timeLeft.seconds).padStart(2, '0')}
        </span>
      </div>
    </div>;
}